"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoCollateralProvenanceType = exports.CryptoCollateralProvenanceStatedUsage = exports.CryptoStatedLiquidAssetVerificationErrorReason = exports.CryptoStatedLiquidAssetVerificationDenialReason = exports.CryptoStatedLiquidAssetVerificationDecision = exports.CryptoConfirmOfferError = exports.CryptoCollateralConfigError = exports.CryptoReservesGateStatus = exports.CryptoWelcomePageMode = exports.CryptoWelcomeProgressStepKey = exports.CRYPTO_OLTV_VARIANT_TO_TIER_NAME = exports.CRYPTO_TIER_NAME_TO_OLTV_VARIANT = exports.isPolicyVariantForCryptoOltv = exports.CRYPTO_OLTV_VARIANTS = exports.CryptoTierName = void 0;
const underwriting_1 = require("./underwriting");
/**
 * Crypto origination types shared between frontend and backend.
 *
 * These types define the wire contract for crypto-backed lending origination flow.
 */
// ============================================================================
// Tier Names and Mappings
// ============================================================================
/**
 * Human-readable tier names for crypto origination.
 * Maps to Argos monitoring strategies (30%/50%/70% OLTV).
 */
/* @TranslateToPython */
var CryptoTierName;
(function (CryptoTierName) {
    CryptoTierName["ThirtyPercentLTV"] = "ThirtyPercentLTV";
    CryptoTierName["FiftyPercentLTV"] = "FiftyPercentLTV";
    CryptoTierName["SeventyPercentLTV"] = "SeventyPercentLTV";
})(CryptoTierName || (exports.CryptoTierName = CryptoTierName = {}));
/**
 * Crypto OLTV variants - references from PolicyVariantType (single source of truth).
 * PolicyVariantType is annotated with @TranslateToPython so both TS and Python share the same enum.
 */
exports.CRYPTO_OLTV_VARIANTS = [underwriting_1.PolicyVariantType.Crypto30PctOltvVariant, underwriting_1.PolicyVariantType.Crypto50PctOltvVariant, underwriting_1.PolicyVariantType.Crypto70PctOltvVariant];
const isPolicyVariantForCryptoOltv = (variant) => {
    return exports.CRYPTO_OLTV_VARIANTS.includes(variant);
};
exports.isPolicyVariantForCryptoOltv = isPolicyVariantForCryptoOltv;
exports.CRYPTO_TIER_NAME_TO_OLTV_VARIANT = {
    [CryptoTierName.ThirtyPercentLTV]: underwriting_1.PolicyVariantType.Crypto30PctOltvVariant,
    [CryptoTierName.FiftyPercentLTV]: underwriting_1.PolicyVariantType.Crypto50PctOltvVariant,
    [CryptoTierName.SeventyPercentLTV]: underwriting_1.PolicyVariantType.Crypto70PctOltvVariant,
};
exports.CRYPTO_OLTV_VARIANT_TO_TIER_NAME = {
    [underwriting_1.PolicyVariantType.Crypto30PctOltvVariant]: CryptoTierName.ThirtyPercentLTV,
    [underwriting_1.PolicyVariantType.Crypto50PctOltvVariant]: CryptoTierName.FiftyPercentLTV,
    [underwriting_1.PolicyVariantType.Crypto70PctOltvVariant]: CryptoTierName.SeventyPercentLTV,
};
var CryptoWelcomeProgressStepKey;
(function (CryptoWelcomeProgressStepKey) {
    CryptoWelcomeProgressStepKey["application"] = "application";
    CryptoWelcomeProgressStepKey["cardShipped"] = "cardShipped";
    CryptoWelcomeProgressStepKey["verifyIdentity"] = "verifyIdentity";
    CryptoWelcomeProgressStepKey["verifyAdditionalReserves"] = "verifyAdditionalReserves";
    CryptoWelcomeProgressStepKey["depositBitcoin"] = "depositBitcoin";
    CryptoWelcomeProgressStepKey["activateCard"] = "activateCard";
    CryptoWelcomeProgressStepKey["reviewingApplication"] = "reviewingApplication";
    CryptoWelcomeProgressStepKey["verifyReserves"] = "verifyReserves";
})(CryptoWelcomeProgressStepKey || (exports.CryptoWelcomeProgressStepKey = CryptoWelcomeProgressStepKey = {}));
var CryptoWelcomePageMode;
(function (CryptoWelcomePageMode) {
    CryptoWelcomePageMode["normal"] = "normal";
    CryptoWelcomePageMode["reserveContingency"] = "reserveContingency";
    CryptoWelcomePageMode["fraudContingency"] = "fraudContingency";
})(CryptoWelcomePageMode || (exports.CryptoWelcomePageMode = CryptoWelcomePageMode = {}));
/**
 * Lifecycle of a crypto stated-liquid-asset (reserves) verification gate, derived from its AFC status. Drives the
 * reserves banners in aven_my for BOTH phases (pre-activation and the post-activation limit increase) off one signal:
 *   notRequired      — no reserves gate (verified/never needed) → no banner
 *   awaitingCustomer — AFC pendingCustomerAction → show the "verify your assets" upload CTA
 *   inReview         — AFC pendingAvenAction (docs submitted) → show the "verifying your assets" ops-review banner
 */
var CryptoReservesGateStatus;
(function (CryptoReservesGateStatus) {
    CryptoReservesGateStatus["notRequired"] = "notRequired";
    CryptoReservesGateStatus["awaitingCustomer"] = "awaitingCustomer";
    CryptoReservesGateStatus["inReview"] = "inReview";
})(CryptoReservesGateStatus || (exports.CryptoReservesGateStatus = CryptoReservesGateStatus = {}));
var CryptoCollateralConfigError;
(function (CryptoCollateralConfigError) {
    CryptoCollateralConfigError["tierNotFound"] = "tierNotFound";
    CryptoCollateralConfigError["creditLimitMismatch"] = "creditLimitMismatch";
    CryptoCollateralConfigError["tierNotAvailableFromPreQual"] = "tierNotAvailableFromPreQual";
    CryptoCollateralConfigError["creditLimitOutOfPolicyRange"] = "creditLimitOutOfPolicyRange";
    CryptoCollateralConfigError["collateralPriceSlippage"] = "collateralPriceSlippage";
    CryptoCollateralConfigError["offerTermsAlreadyAccepted"] = "offerTermsAlreadyAccepted";
})(CryptoCollateralConfigError || (exports.CryptoCollateralConfigError = CryptoCollateralConfigError = {}));
var CryptoConfirmOfferError;
(function (CryptoConfirmOfferError) {
    CryptoConfirmOfferError["fraud"] = "fraud";
    CryptoConfirmOfferError["ofac"] = "ofac";
    CryptoConfirmOfferError["frozenCreditFiles"] = "frozenCreditFiles";
    CryptoConfirmOfferError["cipFailed"] = "cipFailed";
    CryptoConfirmOfferError["invalidStatus"] = "invalidStatus";
    CryptoConfirmOfferError["missingProvenance"] = "missingProvenance";
})(CryptoConfirmOfferError || (exports.CryptoConfirmOfferError = CryptoConfirmOfferError = {}));
var CryptoStatedLiquidAssetVerificationDecision;
(function (CryptoStatedLiquidAssetVerificationDecision) {
    CryptoStatedLiquidAssetVerificationDecision["approved"] = "approved";
    CryptoStatedLiquidAssetVerificationDecision["denied"] = "denied";
})(CryptoStatedLiquidAssetVerificationDecision || (exports.CryptoStatedLiquidAssetVerificationDecision = CryptoStatedLiquidAssetVerificationDecision = {}));
var CryptoStatedLiquidAssetVerificationDenialReason;
(function (CryptoStatedLiquidAssetVerificationDenialReason) {
    CryptoStatedLiquidAssetVerificationDenialReason["incorrectDocType"] = "INCORRECT_DOC_TYPE";
    CryptoStatedLiquidAssetVerificationDenialReason["outdatedDoc"] = "OUTDATED_DOC";
    CryptoStatedLiquidAssetVerificationDenialReason["missingInfo"] = "MISSING_INFO";
})(CryptoStatedLiquidAssetVerificationDenialReason || (exports.CryptoStatedLiquidAssetVerificationDenialReason = CryptoStatedLiquidAssetVerificationDenialReason = {}));
var CryptoStatedLiquidAssetVerificationErrorReason;
(function (CryptoStatedLiquidAssetVerificationErrorReason) {
    CryptoStatedLiquidAssetVerificationErrorReason["notCryptoApplication"] = "NOT_CRYPTO_APPLICATION";
    CryptoStatedLiquidAssetVerificationErrorReason["noCollateralCommitment"] = "NO_COLLATERAL_COMMITMENT";
    CryptoStatedLiquidAssetVerificationErrorReason["noActiveQueueItem"] = "NO_ACTIVE_QUEUE_ITEM";
    CryptoStatedLiquidAssetVerificationErrorReason["insufficientVerifiedAmount"] = "INSUFFICIENT_VERIFIED_AMOUNT";
    CryptoStatedLiquidAssetVerificationErrorReason["invalidRationale"] = "INVALID_RATIONALE";
})(CryptoStatedLiquidAssetVerificationErrorReason || (exports.CryptoStatedLiquidAssetVerificationErrorReason = CryptoStatedLiquidAssetVerificationErrorReason = {}));
var CryptoCollateralProvenanceStatedUsage;
(function (CryptoCollateralProvenanceStatedUsage) {
    CryptoCollateralProvenanceStatedUsage["personalExpenses"] = "personalExpenses";
    CryptoCollateralProvenanceStatedUsage["largePurchaseFinancing"] = "largePurchaseFinancing";
    CryptoCollateralProvenanceStatedUsage["debtConsolidation"] = "debtConsolidation";
})(CryptoCollateralProvenanceStatedUsage || (exports.CryptoCollateralProvenanceStatedUsage = CryptoCollateralProvenanceStatedUsage = {}));
var CryptoCollateralProvenanceType;
(function (CryptoCollateralProvenanceType) {
    CryptoCollateralProvenanceType["employmentIncome"] = "employmentIncome";
    CryptoCollateralProvenanceType["businessOrSelfEmploymentIncome"] = "businessOrSelfEmploymentIncome";
    CryptoCollateralProvenanceType["savingsOrInvestmentProceeds"] = "savingsOrInvestmentProceeds";
    CryptoCollateralProvenanceType["cryptoInvestingOrRewards"] = "cryptoInvestingOrRewards";
    CryptoCollateralProvenanceType["giftOrInheritance"] = "giftOrInheritance";
    CryptoCollateralProvenanceType["other"] = "other";
})(CryptoCollateralProvenanceType || (exports.CryptoCollateralProvenanceType = CryptoCollateralProvenanceType = {}));
